import React, { useCallback, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { useFormik } from 'formik'

import Form from '../../../../components/Form'
import RightsHolderProfileFormContent from './RightsHolderProfileFormContent'

import { transformValuesToBE } from './formatters'

import { clearUpdateSelfAccount, updateSelfAccount } from '../../../../modules/actions/selfAccounts'
import {
  selfAccountSelector,
  updateSelfAccountErrorSelector,
  updateSelfAccountIsLoadingSelector,
  updateSelfAccountSelector,
  updateSelfAccountWasUpdatedSelector
} from '../../../../modules/selectors/selfAccounts'
import { setSelectedPartnership } from '../../../../modules/actions/partnerships'
import {
  selectedPartnershipRightsHolderIdSelector,
  selectedPartnershipSelector
} from '../../../../modules/selectors/partnerships'

import { getInitialValues, validationSchema } from '../fields'

import useStyles from '../../EditProfile/styles'

const RightHolderProfileForm = () => {
  const classes = useStyles()

  const dispatch = useDispatch()
  const { t } = useTranslation()

  const selectedPartnership = useSelector(selectedPartnershipSelector)
  const rightHolderAccountId = useSelector(selectedPartnershipRightsHolderIdSelector)
  const rightHolderAccountData = useSelector(selfAccountSelector)
  const accountWasUpdated = useSelector(updateSelfAccountWasUpdatedSelector)
  const { data: updateSelfAccountData } = useSelector(updateSelfAccountSelector)
  const { name, icon } = updateSelfAccountData

  const initialValues = useMemo(() => getInitialValues(rightHolderAccountData), [rightHolderAccountData])

  const onSubmit = useCallback(
    values => {
      const updatedAccount = transformValuesToBE(values)

      dispatch(updateSelfAccount(rightHolderAccountId, updatedAccount))
    },
    [dispatch, rightHolderAccountId]
  )

  const formik = useFormik({
    initialValues,
    validationSchema,
    enableReinitialize: true,
    onSubmit
  })

  const updateSelectedPartnership = useCallback(() => {
    const updatedPartnership = {
      ...selectedPartnership,
      rights_holder_name: name,
      ...(icon && { icon })
    }

    dispatch(setSelectedPartnership(updatedPartnership))
  }, [dispatch, icon, name, selectedPartnership])

  const clearUpdateSelfAccountHandler = useCallback(() => {
    dispatch(clearUpdateSelfAccount())
  }, [dispatch])

  return (
    <Form
      formik={formik}
      method="post"
      formName="edit_rightHolder_profile"
      successSubmit={accountWasUpdated}
      onSuccessSubmit={updateSelectedPartnership}
      clearHandler={clearUpdateSelfAccountHandler}
      errorSelector={updateSelfAccountErrorSelector}
      isLoadingSelector={updateSelfAccountIsLoadingSelector}
      submitText={t('Save')}
      formFooterClassName={classes.formFooter}
    >
      <RightsHolderProfileFormContent formik={formik} />
    </Form>
  )
}

export default RightHolderProfileForm
